import $ from 'gridstrap/lib/gs-zepto';
import * as locale  from 'gridstrap/lib/gs-locale'

export class GSFormLocaleCountries {

	//
	// Properties
	//

	private root;
	private field;
	private input;

	get isVisible() { return !this.root.hasClass('d-none'); }
	get code()      { return this.field.value; }
	get name()      { return this.field.text; }

	set isVisible(value) { this.root.toggleClass('d-none', !value); }
	set code(value)      { this.field.value = value; }

	//
	// Methods
	//

	focus() {
		this.input.focus();
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
	}

	gsOnInit() {
		this.field = this.root.find('.gs-FormField').gs(0);
		this.input = this.field.input;
		this.input.on('change', () => locale.update(this.field.value));
	}

	gsOnDestroy() {
		this.input.off();
	}
}
